import axios from "../../config/axiosConfig";
import {
  BEAM_REGISTER_REPORT_REQUEST,
  BEAM_REGISTER_REPORT_SUCCESS,
  BEAM_REGISTER_REPORT_FAILURE
} from "../types/beam-register-report-types.js";

export const getBeamRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BEAM_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/beam-report/register?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: BEAM_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: BEAM_REGISTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: BEAM_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearBeamRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: BEAM_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}
